import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import { ConfigProvider, App as AntdApp } from "antd";
import FileBrowser from "./components/FileBrowser";
import "./styles/index.scss";

function App() {
  return (
    <ConfigProvider>
      <AntdApp>
        <Router>
          <Routes>
            <Route path="/" element={<FileBrowser />} />
            <Route path="/:accessToken" element={<FileBrowserWrapper />} />
          </Routes>
        </Router>
      </AntdApp>
    </ConfigProvider>
  );
}

function FileBrowserWrapper() {
  const { accessToken } = useParams<{ accessToken: string }>();
  
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  
  return <FileBrowser accessToken={accessToken} />;
}

export default App;
